import { render, staticRenderFns } from "./QuestionnaireFormModule.vue?vue&type=template&id=36895569"
import script from "./QuestionnaireFormModule.vue?vue&type=script&lang=js"
export * from "./QuestionnaireFormModule.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireFormModule.vue?vue&type=style&index=0&id=36895569&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports